var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Group } from '@/models/Group';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { StudentDocument } from '@/models/StudentDocument';
import { Teacher } from '@/models/Teacher';
import AsyncSelect from '@/components/async-select/AsyncSelect.vue';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { StudentDocumentStatus } from '@/models/StudentDocumentStatus';
import { sortByKey } from '@/support/Object';
import { Lvs } from '@/models/Lvs';
import { DocumentableType, StudentDocumentTemplate, StudentDocumentTemplateIncludes } from '@/models/StudentDocumentTemplate';
import Draggable from '@/components/Draggable/Draggable';
import CurriculumSelectDialog from '@/components/CurriculumSelectDialog/CurriculumSelectDialog';
import PlanTemplateRow from '@/components/PlanTemplateRow/PlanTemplateRow';
import SelectStudentLevelsDialog from '@/views/Users/Student/Dialogs/CreatePlanDialog/SelectStudentLevelsDialog/SelectStudentLevelsDialog.vue';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
import { generatePlanPayload } from '@/support/GeneratePlanPayload';
import { debounce, sortBy } from 'lodash';
let AddStudentDocumentDialog = class AddStudentDocumentDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedStudentId = '';
        this.selectedStudent = null;
        this.currentStep = 1;
        this.newDocument = new StudentDocument();
        this.isValidDocument = false;
        this.teacherModel = new Teacher();
        this.internalSelectedTeachers = [];
        this.isLoading = true;
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.documentStatuses = [];
        this.isLoadingDocumentStatuses = true;
        this.isInitialized = false;
        this.isSaving = false;
        this.studentLvs = [];
        this.isLoadingLvs = true;
        this.curriculum = new CurriculumModel();
        this.isLoadingUserCurriculum = true;
        this.planTemplates = [];
        this.isLoadingPlanTemplates = true;
        this.selectedTemplate = null;
        this.draggableBlockItems = [];
        this.isAddingStep = false;
        this.isShowingCurriculumSelectDialog = false;
        this.savedDocumentId = undefined;
        this.curriculumEditItem = null;
        this.curriculumEditItems = [];
        this.isShowingStudentLevelsDialog = false;
        this.debouncedAutosave = debounce(this.autosave, 3000, { maxWait: 10000 });
        this.requestGeneration = 0;
        // #endregion
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select student'), value: 1 },
                { label: this.$tc('Basic information'), value: 2 },
                { label: this.$tc('Content'), value: 3 },
            ],
            title: this.$tc('Add document to student'),
            customButtons: [
                {
                    label: this.$tc('student_plan.dialog.save'),
                    action: async () => {
                        const isPublish = true;
                        await this.createDocument(isPublish);
                    },
                    visible: this.currentStep === 3,
                },
            ],
        };
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        const generation = ++this.requestGeneration;
        await Promise.all([
            this.fetchPlanTemplates(generation),
            this.fetchDocumentStatuses(generation),
            this.fetchUserLvs(generation),
            this.fetchCurriculum(generation),
        ]);
        if (!this.newDocument.blocks || !this.newDocument.blocks.length) {
            this.newDocument.blocks = [];
            this.appendBlock();
        }
        else {
            this.createPlanBlocksDraggableItems(true);
        }
        this.isLoading = false;
        this.$nextTick(() => {
            if (this.newDocument.teachers && this.newDocument.teachers.length) {
                this.selectedTeachers = this.newDocument.teachers.map((teacher) => ({
                    value: teacher.user.id || '',
                    text: teacher.user.name || '',
                    permission: teacher.permission || 'view',
                }));
                this.teacherSelectInput.setDefaultValue(this.selectedTeachers, false);
            }
            this.$refs.teacherSelect.querySelections('');
            this.isInitialized = true;
        });
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    closeCurriculumSelectDialog(subjects) {
        if (subjects && subjects.length) {
            this.addSubjects(subjects);
        }
        this.isShowingCurriculumSelectDialog = false;
    }
    onClickEditExistingCurriculum(item, subjects) {
        this.isShowingCurriculumSelectDialog = true;
        this.curriculumEditItem = item;
        this.curriculumEditItems = subjects;
    }
    editExistingCurriculum(emit) {
        !emit.items.length ? this.onRemoveObjective(emit.item) : this.editDragItem(emit);
        this.isShowingCurriculumSelectDialog = false;
    }
    cancelDebouncedPayload() {
        this.debouncedAutosave.cancel();
    }
    editDragItem(emit) {
        const item = this.draggableBlockItems.find((item) => item.id === emit.item.id);
        if (!item) {
            return;
        }
        item.block.student_subjects = emit.items;
    }
    addSubjects(subjects) {
        this.appendBlock({
            title: '',
            content: '',
            id: '',
            sort: this.draggableBlockItems.length - 1,
            type: 'plp',
            student_subjects: subjects,
        });
    }
    isPlp(draggableStudentDocumentBlock) {
        return draggableStudentDocumentBlock.block.type === 'plp';
    }
    fillTemplates() {
        const foundTemplates = this.planTemplates.find((template) => template.id === (this.selectedTemplate && this.selectedTemplate.id));
        // foundTemplates.forEach((template) => this.createPlanBlocksDraggableItems(template));
        if (foundTemplates && foundTemplates.blocks) {
            this.draggableBlockItems = [];
            this.newDocument.blocks = [];
            foundTemplates.blocks.forEach((template) => this.appendBlock(template));
            // this.planCopy.blocks = [...foundTemplates.blocks];
            // this.createPlanBlocksDraggableItems();
        }
    }
    onClickAddStudentLvs(lvs) {
        this.appendBlock({
            title: lvs.name,
            content: lvs.lvs_note,
            id: lvs.id,
            type: 'lvs',
            sort: this.draggableBlockItems.length - 1,
        });
    }
    onShareWithAllTeachersEditableChanged(value) {
        if (value) {
            this.$set(this.newDocument, 'is_visible_for_teachers', false);
            this.clearSelectedTeachers();
        }
    }
    onShareWithAllTeachersVisibleChanged(value) {
        if (value) {
            this.$set(this.newDocument, 'is_editable_for_teachers', false);
            this.clearSelectedTeachers();
        }
    }
    clearSelectedTeachers() {
        const teacherSelect = this.$refs.teacherSelect;
        this.selectedTeachers.forEach((teacher) => teacherSelect?.removeSelected(teacher));
        this.selectedTeachers = [];
    }
    openStudentLevelsDialog() {
        this.isShowingStudentLevelsDialog = true;
    }
    openCurriculumSelectDialog() {
        this.isShowingCurriculumSelectDialog = true;
    }
    onReOrder(event) {
        this.draggableBlockItems = sortBy(this.draggableBlockItems, (item) => event.items.indexOf(item.id));
        this.newDocument.blocks = this.draggableBlockItems.map((item) => item.block);
    }
    onReset() {
        this.selectedStudentId = '';
        this.selectedStudent = null;
        this.currentStep = 1;
    }
    onClose() {
        this.onReset();
        this.$emit('close');
    }
    async onSelectedStudent(value) {
        if (!Object.keys(value).length) {
            this.selectedStudentId = '';
            this.selectedStudent = null;
            return;
        }
        const id = Object.keys(value).find((key) => value[key]);
        if (!id) {
            this.selectedStudentId = '';
            return;
        }
        this.$set(this, 'selectedStudentId', id);
        this.getStudent();
        const generation = ++this.requestGeneration;
        await Promise.all([
            this.fetchPlanTemplates(generation),
            this.fetchDocumentStatuses(generation),
            this.fetchUserLvs(generation),
            this.fetchCurriculum(generation),
        ]);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
        console.log('this.currentStep: ', this.currentStep);
        if (this.currentStep === 2) {
            this.$refs.teacherSelect.querySelections('');
        }
    }
    getStudent() {
        if (!this.selectedStudentId) {
            return;
        }
        const students = this.group.users;
        if (!students || !students.length) {
            return;
        }
        this.selectedStudent = students.find((student) => student.id === this.selectedStudentId);
    }
    onRemoveTeacher(teacher) {
        this.internalSelectedTeachers = this.internalSelectedTeachers.filter((selectedTeacher) => selectedTeacher.value !== teacher.value);
        this.$refs.teacherSelect.removeSelected(teacher);
    }
    createPlanBlocksDraggableItems(isExistingBlock = false) {
        if (this.newDocument && this.newDocument.blocks && this.newDocument.blocks.length) {
            this.newDocument.blocks.forEach((block) => this.appendBlock(block, isExistingBlock));
        }
    }
    appendBlockByType(type = 'text') {
        const newBlock = this.getEmptyStudentBlock(type);
        this.appendBlock(newBlock);
    }
    appendBlock(block, isExistingBlock = false) {
        this.isAddingStep = true;
        if (!this.newDocument.blocks) {
            this.newDocument.blocks = [];
        }
        const newBlock = block || this.getEmptyStudentBlock();
        const draggableStudentDocumentBlock = this.transformToDraggableItem(newBlock);
        this.draggableBlockItems.push(draggableStudentDocumentBlock);
        if (!isExistingBlock) {
            this.newDocument.blocks.push(newBlock);
        }
        this.isAddingStep = false;
    }
    getEmptyStudentBlock(type = 'text') {
        return {
            content: '',
            title: type === 'simple-text' ? '' : '',
            id: '',
            sort: 0,
            type,
        };
    }
    transformToDraggableItem(block) {
        return {
            id: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, '')
                .substr(0, 5),
            block,
        };
    }
    onRemoveObjective(draggableItem) {
        this.openConfirmDeleteDialog(draggableItem);
    }
    openConfirmDeleteDialog(draggableItem) {
        this.$store.dispatch('openDialog', this.removeObjectiveDialogOptions(draggableItem));
    }
    removeObjectiveDialogOptions(draggableItem) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('scoollinks.dialog.delete.text').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        this.removeObjective(draggableItem);
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    removeObjective(draggableItem) {
        this.isAddingStep = true;
        if (!this.newDocument.blocks) {
            return;
        }
        const itemIndex = this.newDocument.blocks.findIndex((item) => draggableItem.block.id === item.id);
        if (this.draggableBlockItems) {
            this.draggableBlockItems = this.draggableBlockItems.filter((item) => item.id !== draggableItem.id);
        }
        if (itemIndex > -1) {
            this.newDocument.blocks.splice(itemIndex, 1);
        }
        this.isAddingStep = false;
    }
    formatBlocksPayload() {
        const blocksPayload = [];
        if (this.newDocument.blocks) {
            this.newDocument.blocks.forEach((block) => {
                if (block.type === 'plp') {
                    blocksPayload.push({
                        type: block.type,
                        student_subjects: block.student_subjects ? block.student_subjects.map((block) => (block.id ? block.id : '')) : [],
                        sort: block.sort,
                    });
                }
                else {
                    blocksPayload.push({
                        title: block.title,
                        content: block.content,
                        sort: block.sort,
                        type: block.type,
                    });
                }
            });
        }
        return blocksPayload;
    }
    generatePlanCreatePayload(isPublish = false) {
        if (!this.selectedStudent) {
            return {};
        }
        return generatePlanPayload({
            plan: this.newDocument,
            blocks: this.formatBlocksPayload(),
            documentableType: DocumentableType.USER,
            entityId: this.selectedStudent.id,
            entityFieldName: 'user_id',
            selectedTeachers: this.selectedTeachers,
            isPublish,
            id: this.savedDocumentId,
        });
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchCurriculum(generation) {
        this.curriculum
            .current()
            .include(['children', 'subjects'])
            .first()
            .then((curriculum) => {
            if (generation !== this.requestGeneration)
                return;
            this.curriculum = curriculum;
            const areas = this.curriculum.subjects || [];
            areas.forEach((area, index) => {
                this.curriculum.subjects[index] = this.curriculum.dataToModel(area, 'Subject');
                const topics = this.curriculum.subjects[index].children || [];
                topics.forEach((topic, i) => {
                    this.curriculum.subjects[index].children[i] = this.curriculum.dataToModel(topic, 'Subject');
                });
                topics.sort(sortByKey('name'));
                this.$set(this.curriculum.subjects[index], 'children', topics);
            });
            areas.sort(sortByKey('name'));
            this.$set(this.curriculum.subjects, 'subjects', areas);
            this.isLoadingUserCurriculum = false;
        });
    }
    async fetchUserLvs(generation) {
        this.isLoadingLvs = true;
        new Lvs()
            .filter({ users: [this.selectedStudentId] })
            .all()
            .then((result) => {
            if (generation !== this.requestGeneration)
                return;
            if (Array.isArray(result)) {
                this.studentLvs = result.map((area) => {
                    return {
                        id: area.id,
                        name: area.name,
                        lvs_note: area.users[this.selectedStudentId].notes,
                    };
                });
            }
            this.isLoadingLvs = false;
        })
            .catch((error) => {
            if (generation !== this.requestGeneration)
                return;
            ErrorHandler.network(error);
            this.isLoadingLvs = false;
        });
    }
    async fetchDocumentStatuses(generation) {
        this.isLoadingDocumentStatuses = true;
        const result = await new StudentDocumentStatus().all();
        if (generation !== this.requestGeneration)
            return;
        this.documentStatuses = result;
        this.isLoadingDocumentStatuses = false;
    }
    async fetchPlanTemplates(generation) {
        this.isLoadingPlanTemplates = true;
        const result = await new StudentDocumentTemplate().include([StudentDocumentTemplateIncludes.BLOCKS]).all();
        if (generation !== this.requestGeneration)
            return;
        this.planTemplates = result;
        this.isLoadingPlanTemplates = false;
    }
    async autosave() {
        if (!this.isInitialized || this.isSaving)
            return;
        await this.saveDocument(false);
    }
    async createDocument(isPublish = false) {
        if (!this.selectedStudent || !this.isValidDocument) {
            return;
        }
        this.cancelDebouncedPayload();
        await this.saveDocument(isPublish);
    }
    async saveDocument(isPublish) {
        this.isSaving = true;
        if (isPublish) {
            this.isLoading = true;
        }
        try {
            const plan = await new StudentDocument().create(this.generatePlanCreatePayload(isPublish));
            if (!plan)
                return;
            this.savedDocumentId = plan.id || this.savedDocumentId;
            if (isPublish) {
                this.onReset();
                this.$emit('submitted');
                return;
            }
            this.$emit('updated');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isSaving = false;
            this.isLoading = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get canShowDeleteIcon() {
        return !!(this.draggableBlockItems && this.draggableBlockItems.length > 1);
    }
    get required() {
        return (value) => {
            return !!value || 'Field is required';
        };
    }
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return !this.selectedStudentId;
            case 2:
                return !this.isValidDocument;
            default:
                return false;
        }
    }
    get teacherSelectInput() {
        return this.$refs.teacherSelect;
    }
    get selectedTeachers() {
        return this.internalSelectedTeachers;
    }
    set selectedTeachers(value) {
        this.internalSelectedTeachers = value.map((teacher) => {
            const oldTeacher = this.internalSelectedTeachers.find((selectedTeacher) => selectedTeacher.value === teacher.value);
            if (!('permission' in teacher)) {
                if (oldTeacher && 'permission' in oldTeacher) {
                    teacher.permission = oldTeacher.permission;
                }
                else {
                    teacher.permission = 'view';
                }
            }
            return teacher;
        });
    }
    get teacherViewOptions() {
        return [
            { name: this.$tc('View and edit'), id: 'edit' },
            { name: this.$tc('View'), id: 'view' },
        ];
    }
    // #endregion
    // #region @Watchers
    onPlanCopyChanged() {
        if (!this.isInitialized || this.isSaving)
            return;
        this.debouncedAutosave();
    }
    onSelectedTeachersChanged() {
        if (!this.isInitialized || this.isSaving)
            return;
        this.debouncedAutosave();
    }
    onCurrentStepChangedWatcher() {
        console.log('this.currentStep: ', this.currentStep);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], AddStudentDocumentDialog.prototype, "group", void 0);
__decorate([
    Watch('newDocument', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddStudentDocumentDialog.prototype, "onPlanCopyChanged", null);
__decorate([
    Watch('internalSelectedTeachers', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddStudentDocumentDialog.prototype, "onSelectedTeachersChanged", null);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddStudentDocumentDialog.prototype, "onCurrentStepChangedWatcher", null);
AddStudentDocumentDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            StudentSelector,
            LabelValue,
            AQuillEditor,
            AsyncSelect,
            CurriculumSelectDialog,
            PlanTemplateRow,
            Draggable,
            SelectStudentLevelsDialog,
        },
    })
], AddStudentDocumentDialog);
export default AddStudentDocumentDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
